import React, {useEffect} from "react";
import {Apis} from "../util/data";
import axios from "axios";
import {errorToast, successToast} from "./layout/ToastStyles";
import Input from "./forms/FormEl";
import FormGroup from "./forms/FormGroup";
import {useForm} from "react-hook-form";

const CancelCita =({setAction, setTitle,...props}) => {


  const cancel = async (formData) => {
    formData.id = props.id;
    try {
      const {data} = await axios.post(Apis.PROD + '/cita-consejeria/cancelar' , formData)
      if(data) successToast("Se ha cancelado correctamente")
    }
    catch (error){
      errorToast("Error al cancelar")
      console.log(error)
    }
  }

  const {register, handleSubmit, formState: {errors}} = useForm();

  useEffect(() => {
    setTitle("Cancelar cita")
    setAction(()=>handleSubmit(cancel))
  }, [props.id])

  return (
    <form>
      <FormGroup>
        <label>Motivo</label>
        <Input type='text' {...register("motivo", {required: "Campo obligatorio"})}/>
        {errors.motivo && <p style={{color: 'red'}}>{errors.motivo?.message}</p>}
      </FormGroup>
    </form>
  );

}

export default CancelCita;